module.exports = __webpack_public_path__ + "media/images/catedra_inditex_logo-d411037653a07d12529ef3197076f766.svg";